import React, {useContext} from "react";
import {Link, useLocation} from "react-router-dom";
import {Link as ScrollLink} from "react-scroll";
import {SideMenuContext, createActiveState} from "../../context/SideMenuContext";
import {Tooltip} from "antd";

const SideMenuItem = ({
  id,
  name,
  type,
  activeState,
  setActiveState,
  methodIndex,
  component,
  setSchemaActive,
  setOpenSchema,
  subEntityIndex,
  setOpenSubMenu,
}) => {
  const {state, dispatch} = useContext(SideMenuContext);

  const location = useLocation();

  const onClickActive = ((id, methodName)=>{
    const newMethodName = methodName.replaceAll(" ", "-");
    const currentPath = `${location?.pathname.split("/").slice(0, 3).join("/")}#${newMethodName}`;
    window.history.pushState(null, null, currentPath);
    setTimeout(()=>{
      if (component==="apiDetail") {
        dispatch(createActiveState(Number(id)));
      } else {
        setActiveState(Number(id));
        setSchemaActive(false);
        setOpenSchema(false);
        setOpenSubMenu(subEntityIndex);
      }
    }, 100);
  });

  const isActive = activeState === id;
  return (
    <>
      <li>
        <ScrollLink
          activeClass="none"
          to={`${id}`}
          spy={true}
          smooth={false}
          offset={-140}
          onClick={() =>
            onClickActive(id, name)}
        >
          <Link
            className={
              isActive ?
                "toc-h4 toc-link side-menu-methods active" :
                "toc-h4 toc-link side-menu-methods"
            }
            id={`${name + "sidemenu"}`}
          >
            <span className="sidebar-link-text sidebar-item-link" id={name}>
              <Tooltip placement="bottom" title={name}>
                {name}
              </Tooltip>
            </span>
            <span className={`api-method ${type?.toLowerCase()}`}>{type}</span>
          </Link>
        </ScrollLink>
      </li>
    </>
  );
};

export default SideMenuItem;
